var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65306 2.62338H2.67989C2.02558 2.62338 1.49414 3.15482 1.49414 3.80913V13.8142C1.49414 14.4686 2.02558 15 2.67989 15H9.65306C10.3074 15 10.8388 14.4686 10.8388 13.8142V3.80913C10.8357 3.15482 10.3043 2.62338 9.65306 2.62338ZM10.0063 13.8112C10.0063 14.0078 9.84659 14.1675 9.64999 14.1675H2.67682C2.48021 14.1675 2.32048 14.0078 2.32048 13.8112V3.80913C2.32048 3.61253 2.48021 3.45279 2.67682 3.45279H9.64999C9.84659 3.45279 10.0063 3.61253 10.0063 3.80913V13.8112Z",
    fill: "#B4B4B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3191 0H5.3459C4.69159 0 4.16016 0.531436 4.16016 1.18575C4.16016 1.41614 4.34447 1.60045 4.57486 1.60045C4.80525 1.60045 4.98956 1.41614 4.98956 1.18575C4.98956 0.989146 5.1493 0.829408 5.3459 0.829408H12.3191C12.5157 0.829408 12.6754 0.989146 12.6754 1.18575V11.1909C12.6754 11.3875 12.5157 11.5472 12.3191 11.5472C12.0887 11.5472 11.9044 11.7315 11.9044 11.9619C11.9044 12.1923 12.0887 12.3766 12.3191 12.3766C12.9734 12.3766 13.5048 11.8452 13.5048 11.1909V1.18575C13.5048 0.531436 12.9734 0 12.3191 0Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.684fa134de9cc62cbb758c527097c398.svg";
export { ForwardRef as ReactComponent };